import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "vazirmatn/Vazirmatn-font-face.css";
import "./styles.css";

/**
 * سرویس‌ورکر — فقط برای اینکه اپ نصب‌شدنی باشد و آفلاین باز شود.
 * روی http ثبت نمی‌شود (جز localhost) و اگر مرورگر پشتیبانی نکند، اپ عادی کار می‌کند.
 */
const secure = location.protocol === "https:" || location.hostname === "localhost";
if ("serviceWorker" in navigator && secure) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((reg) => {
        // نسخهٔ جدید بدون معطلی جای قبلی را می‌گیرد
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          sw?.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage("skip-waiting");
            }
          });
        });
      })
      .catch(() => {
        // ثبت نشد — اپ بدون آن هم کامل کار می‌کند
      });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
